/* global google, GMaps, MarkerClusterer */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import moment from 'moment';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
import * as constants from '../../util/constants';
import helpers from '../../util/helpers';

const MapSkeleton = () => {
  return (
    <div className="map-wrapper skeleton-shine" />
  );
};

class AppGlobalHotelsMap extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      searchedLocation: {},
      allHotelLocations: [],
      mapHotelItemsShow: true,
    };

    // Assign first state
    const $activeViewTypeItem = $('#global-hotels-view-types .view-type-item.active');
    const initialViewType = $activeViewTypeItem.length ? $activeViewTypeItem.data('view') : 'grid';

    this.state = Object.assign({}, this.initialState, { viewType: initialViewType });

    this.location = '';
    this.locationLat = null;
    this.locationLng = null;
    this.facilities = '';
    this.map = null;
    this.mapHotelMarkers = [];

    this.isMapDataStale = true;

    this.mapHotelItemsSectionRef = React.createRef();
    this.mapHotelItemsSectionObserver = null;

    const location = helpers.getParameterByName('location');
    if (location != null && location.length) {
      this.location = location;
    }

    // Bind "this"
    this.getCurrentLocation = this.getCurrentLocation.bind(this);
    this.loadSearchResults = this.loadSearchResults.bind(this);
    this.handleHotelLocationsVisibility = this.handleHotelLocationsVisibility.bind(this);
    this.loadMap = this.loadMap.bind(this);
    this.activateMapView = this.activateMapView.bind(this);
    this.handleMapHotelItemsToggleClick = this.handleMapHotelItemsToggleClick.bind(this);
    this.handleMapHotelItemClick = this.handleMapHotelItemClick.bind(this);
    this.handleMapHotelItemsSlide = this.handleMapHotelItemsSlide.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
    this.searchGen = 0;
  }

  activateMapView() {
    if (!this.isMapDataStale) {
      return;
    }

    const searchGen = (this.searchGen = (this.searchGen || 0) + 1);

    if (this.location === 'Current Location') {
      this.getCurrentLocation(() => {
        if (searchGen !== this.searchGen) {
          return;
        }
        this.loadSearchResults(searchGen);
      });
    } else {
      this.loadSearchResults(searchGen);
    }
  }

  componentDidMount() {
    // The page may already be rendering in map view (a direct ?view=map load) with
    // no toggle click to trigger a fetch, so check on mount too.
    if (this.state.viewType === 'map') {
      this.activateMapView();
    }

    $(document).on(constants.EVENT_VIEW_TYPE_CHANGED, (e, view) => {
      this.setState({
        viewType: view,
      });

      if (view === 'map') {
        this.activateMapView();
      }
    });

    // Reload results
    $(document).on(constants.EVENT_SUBMIT_CLICKED_SEARCH, (e, location) => {
      if (this.location !== location) {
        this.location = location;
        this.isMapDataStale = true;

        if (this.state.viewType === 'map') {
          this.activateMapView();
        }
      }
    });

    $(document).on(constants.EVENT_FACILITES_FILTER_CHANGED_SEARCH, (e, facilities) => {
      if (this.facilities !== facilities) {
        this.facilities = facilities;
        this.isMapDataStale = true;

        if (this.state.viewType === 'map') {
          this.isMapDataStale = false;

          this.setState((prevState) => ({
            allHotelLocations: this.handleHotelLocationsVisibility(prevState.allHotelLocations),
          }), () => {
            this.loadMap();
          });
        }
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.viewType === 'map' && prevState.loading && !this.state.loading) {
      this.loadMap();
      this.handleMapHotelItemsSlide();
    }
  }

  componentWillUnmount() {
    if (this.mapHotelItemsSectionObserver) {
      this.mapHotelItemsSectionObserver.disconnect();
    }
  }

  getCurrentLocation(callback) {
    if (!navigator.geolocation) {
      this.locationLat = null;
      this.locationLng = null;
      if (typeof callback === 'function') {
        callback();
      }
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.locationLat = position.coords.latitude;
        this.locationLng = position.coords.longitude;
        if (typeof callback === 'function') {
          callback();
        }
      },
      () => {
        this.locationLat = null;
        this.locationLng = null;
        if (typeof callback === 'function') {
          callback();
        }
      }
    );
  }

  loadSearchResults(searchGen) {
    // Stop loading old results
    if (this.state.loading) {
      this.source.cancel('Cancelled retrieving data');
      this.source = axios.CancelToken.source();
    }

    // Reset state
    this.setState(this.initialState);

    // Params
    const params = {
      'location': this.location,
      'locationLat': this.locationLat,
      'locationLng': this.locationLng,
    };

    // Send request
    axios.get(`${window.Rydges['restUrl']}global-hotel-locations`, {
      params: params,
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (searchGen !== this.searchGen) {
        // A newer search (location/facilities change) started before this one
        // resolved - drop the response instead of rendering the wrong location.
        return;
      }

      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        const hotelsCount = response['hotels_count'];
        const searchedLocation = response['searched_location'];
        const hotelLocations = [...response['hotel_locations']];

        // A genuine response (even zero results) means the view no longer needs a retry.
        this.isMapDataStale = false;

        if (0 === hotelsCount) {
          this.setState({ loading: false });
        } else {
          this.setState({
            loading: false,
            searchedLocation: searchedLocation,
            allHotelLocations: this.handleHotelLocationsVisibility(hotelLocations),
          });
        }
      }
    }).catch((error) => {
      console.log(error);

      if (axios.isCancel(error) || searchGen !== this.searchGen) {
        return;
      }

      this.setState({ loading: false });
    });
  }

  loadMap() {
    if ($('#global-hotels-map').length) {
      const {
        searchedLocation,
        allHotelLocations,
      } = this.state;

      if (allHotelLocations.length > 0) {
        this.map = new GMaps({
          div: '#global-hotels-map',
          scrollwheel: false,
          center: new google.maps.LatLng(allHotelLocations[0]['address']['lat'], allHotelLocations[0]['address']['lng']),
          zoom: 15,
          zoomControl: true,
          zoomControlOpt: {
            style: 'SMALL',
            position: google.maps.ControlPosition.RIGHT_BOTTOM,
          },
          panControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          overviewMapControl: false,
          rotateControl: false,
          scaleControl: false,
          fullscreenControl: false,
          markerClusterer: function(map) {
            return new MarkerClusterer(map, null, {
              styles: [
                {
                  textColor: 'white',
                  textSize: 20,
                  url: window.Rydges['assetsPath'] + 'images/map-markers/blank.svg',
                  height: 62,
                  width: 62,
                },
              ],
            });
          },
        });

        this.mapHotelMarkers = [];
        const bounds = [];

        if (searchedLocation && Object.keys(searchedLocation).length > 0) {
          bounds.push(new google.maps.LatLng(searchedLocation['lat'], searchedLocation['lng']));

          this.map.addMarker({
            lat: searchedLocation['lat'],
            lng: searchedLocation['lng'],
            icon: {
              url: window.Rydges['assetsPath'] + 'images/map-markers/hotels-star.svg',
              scaledSize: new google.maps.Size(32, 32),
            },
          });
        }

        let activeMarker = null;
        const defaultPin = window.Rydges['assetsPath'] + 'images/map-markers/hotels.svg';
        const activePin = window.Rydges['assetsPath'] + 'images/map-markers/hotels-red.svg';
        const mapMarkerInfoWindowTemplate = $('#hotels-map-marker-info-window').html();

        for (let i = 0; i < allHotelLocations.length; i++) {
          if (Object.keys(allHotelLocations[i]['address']).length > 0) {
            const title = allHotelLocations[i]['title'];
            const lat = allHotelLocations[i]['address']['lat'];
            const lng = allHotelLocations[i]['address']['lng'];
            const link = allHotelLocations[i]['link'];

            bounds.push(new google.maps.LatLng(lat, lng));

            const marker = this.map.addMarker({
              lat: lat,
              lng: lng,
              title: title,
              icon: {
                url: defaultPin,
                scaledSize: new google.maps.Size(32, 32),
              },
              infoWindow: {
                content: helpers.transformMapMarkerInfoWindow({
                  title,
                  hasImage: allHotelLocations[i]['image'].length > 0 ? 'show' : '',
                  image: allHotelLocations[i]['image'],
                  imageAlt: allHotelLocations[i]['image_alt'] || title || 'Hotel',
                  hasRibbonLabel: allHotelLocations[i]['ribbon_label'].length > 0 ? 'show' : '',
                  ribbonLabel: allHotelLocations[i]['ribbon_label'],
                  address: allHotelLocations[i]['address']['address'],
                  hasLocationDistance: allHotelLocations[i]['location_distance'].length > 0 ? 'show' : '',
                  locationDistance: allHotelLocations[i]['location_distance'],
                  bookLink: allHotelLocations[i]['book_link'],
                  link,
                }, mapMarkerInfoWindowTemplate),
                pixelOffset: new google.maps.Size(0, -10),
              },
              click() {
                if (activeMarker) {
                  activeMarker.setIcon({
                    url: defaultPin,
                    scaledSize: new google.maps.Size(32, 32),
                  });
                }
                this.setIcon({
                  url: activePin,
                  scaledSize: new google.maps.Size(32, 32),
                });
                activeMarker = this;

                setTimeout(() => {
                  const gmStyleIw = $('.gm-style-iw');
                  const gmArrow = gmStyleIw.prev().find('div').eq(2);
                  gmArrow.parent().find('div').eq(0).hide();
                  gmArrow.hide();
                }, 10);
              },
            });

            marker._hotelId = allHotelLocations[i]['id'];

            if (allHotelLocations[i].visible === false) {
              if (this.map.markerClusterer) {
                this.map.markerClusterer.removeMarker(marker, true);
              } else {
                marker.setMap(null);
              }
            }

            this.mapHotelMarkers.push(marker);
          }
        }

        if (allHotelLocations.length > 1) {
          this.map.fitLatLngBounds(bounds);
        }

        if (this.map.markerClusterer) {
          this.map.markerClusterer.repaint();
        }
      }
    }
  }

  handleHotelLocationsVisibility(data) {
    const selectedFacilities = this.facilities && this.facilities.length ? this.facilities.split(',') : [];

    return data.map((hotel) => {
      const hotelFacilities = Array.isArray(hotel['facilities']) ? hotel['facilities'] : [];
      const visible = !selectedFacilities.length || selectedFacilities.every((facility) => hotelFacilities.indexOf(facility) > -1);

      return { ...hotel, visible };
    });
  }

  handleMapHotelItemsToggleClick(e) {
    e.preventDefault();

    this.setState((prevState) => ({
      mapHotelItemsShow: !prevState.mapHotelItemsShow,
    }));
  }

  handleMapHotelItemClick(e, id) {
    e.preventDefault();

    const marker = this.mapHotelMarkers.find((m) => m._hotelId === id);
    if (!marker) {
      return;
    }

    const map = this.map.map;
    const projection = map.getProjection();
    if (!projection) {
      return;
    }

    map.setZoom(17);
    const zoom = map.getZoom();
    const scale = Math.pow(2, zoom);
    const worldPoint = projection.fromLatLngToPoint(marker.getPosition());
    let pixelOffsetX = 0;

    if ($(window).width() >= 768) {
      const sidebarWidth = 450;
      const offsetX = sidebarWidth / 2;
      pixelOffsetX = offsetX / scale;
    }

    const newCenterPoint = new google.maps.Point(
      worldPoint.x - pixelOffsetX,
      worldPoint.y
    );
    const newLatLng = projection.fromPointToLatLng(newCenterPoint);

    this.mapHotelMarkers.forEach((m) => {
      if (m.infoWindow) {
        m.infoWindow.close();
      }
    });
    map.setZoom(17);
    map.panTo(newLatLng);
    marker.infoWindow.open(map, marker);
    google.maps.event.trigger(marker, 'click');
  }

  handleMapHotelItemsSlide() {
    const container = this.mapHotelItemsSectionRef && this.mapHotelItemsSectionRef.current;

    if (this.mapHotelItemsSectionObserver) {
      this.mapHotelItemsSectionObserver.disconnect();
      this.mapHotelItemsSectionObserver = null;
    }

    if ($(window).width() < 767 && container) {
      const slides = container.querySelectorAll('.map-hotel-item-wrapper');

      this.mapHotelItemsSectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const dataId = entry.target.getAttribute('data-id');
              this.handleMapHotelItemClick({ preventDefault: () => {} }, parseInt(dataId));
            }
          });
        },
        {
          root: container,
          threshold: 0.5,
        }
      );

      slides.forEach((slide) => this.mapHotelItemsSectionObserver.observe(slide));
    }
  }

  render() {
    const {
      loading,
      allHotelLocations,
      mapHotelItemsShow,
    } = this.state;
    const visibleHotelLocations = allHotelLocations.filter((hotel) => hotel['visible'] !== false);

    return (
      <React.Fragment>
        {
          !loading
            ? (
              <div className="map-container-inner">
                {
                  visibleHotelLocations.length > 0 && (
                    <div className={`map-hotel-items-container ${mapHotelItemsShow ? 'show' : ''}`}>
                      <img src={window.Rydges['assetsPath'] + 'images/icons/right-double-chevron-circle.svg'}
                        className="map-hotel-items-toggle"
                        onClick={this.handleMapHotelItemsToggleClick}
                        alt="Toggle map hotels list"
                      />
                      <div ref={this.mapHotelItemsSectionRef} className="map-hotel-items-wrapper">
                        {
                          visibleHotelLocations.map((hotel, i) => {
                            return (
                              <div key={i} className="map-hotel-item-wrapper" data-id={hotel['id']}>
                                <div className="map-hotel-item" onClick={(e) => this.handleMapHotelItemClick(e, hotel['id'])}>
                                  {
                                    hotel['image'].length > 0 && (
                                      <div className="map-hotel-item-image-container">
                                        {
                                          hotel['ribbon_label'].length > 0 && (
                                            <div className="ribbon small">
                                              <div className="ribbon-inner">
                                                {hotel['ribbon_label']}
                                              </div>
                                            </div>
                                          )
                                        }
                                        <div className="map-hotel-item-image-wrapper">
                                          <img className="map-hotel-item-image" src={hotel['image']} alt={hotel['image_alt'] || hotel['title'] || 'Hotel'} />
                                        </div>
                                      </div>
                                    )
                                  }
                                  <div className="map-hotel-item-content-container">
                                    {
                                      hotel['title'].length > 0 && (
                                        <div className="map-hotel-item-title">
                                          {hotel['title']}
                                        </div>
                                      )
                                    }
                                    {
                                      Object.keys(hotel['address']).length > 0 &&
                                      hotel['address']['address'].length > 0 && (
                                        <div className="map-hotel-item-address">
                                          {hotel['address']['address']}
                                        </div>
                                      )
                                    }
                                    {
                                      hotel['location_distance'].length > 0 && (
                                        <div className="map-hotel-item-location-distance">
                                          <img src={window.Rydges['assetsPath'] + 'images/icons/pin-3-grey.svg'}
                                            width={20}
                                            alt="Location"
                                          />
                                          {hotel['location_distance']}
                                        </div>
                                      )
                                    }
                                    {
                                      hotel['book_link'].length > 0 && (
                                        <div className="map-hotel-item-button-wrapper">
                                          <a href={hotel['book_link']}
                                            className="btn btn-red text-uppercase"
                                            onClick={(e) => e.stopPropagation()}
                                          >
                                            Book Now
                                          </a>
                                        </div>
                                      )
                                    }
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        }
                      </div>
                    </div>
                  )
                }
                <div id="global-hotels-map" className="map-wrapper" />
              </div>
            ) : (
              <MapSkeleton />
            )
        }
      </React.Fragment>
    );
  }
}

// Current location
let currentLocationLat = null;
let currentLocationLng = null;
const getCurrentLocation = (callback) => {
  if (!navigator.geolocation) {
    currentLocationLat = null;
    currentLocationLng = null;
    if (typeof callback === 'function') {
      callback();
    }
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      currentLocationLat = position.coords.latitude;
      currentLocationLng = position.coords.longitude;
      if (typeof callback === 'function') {
        callback();
      }
    },
    () => {
      currentLocationLat = null;
      currentLocationLng = null;
      if (typeof callback === 'function') {
        callback();
      }
    }
  );
};

// Recent-viewed cookie
const saveRecentViewed = (name, brand) => {
  if (!name) {
    return;
  }

  let recentViewed = JSON.parse(helpers.docCookies.getItem(constants.COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_VIEWED)) || [];
  if (recentViewed === null) {
    return;
  }

  const data = { name, brand };
  recentViewed = recentViewed.filter((item) => item['name'] !== data['name']);
  recentViewed.unshift(data);
  helpers.docCookies.setItem(
    constants.COOKIE_KEY_ACCOMMODATION_SEARCH_RECENT_VIEWED,
    JSON.stringify(recentViewed.slice(0, 3)),
    30 * 86400,
    '/'
  );
};

// Telegraph
const checkIfTelegraphEnabled = ({ hotelCode, hotelBrand }) => {
  const { BookingWidget } = window;
  if (!BookingWidget) {
    return false;
  }

  const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
    const location = BookingWidget['allBrandsLocations'][key];
    return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
  });

  if (!hotelKey) {
    return false;
  }

  return BookingWidget['allBrandsLocations'][hotelKey]['redirectToTelegraph'] || false;
};

const redirectToTelegraph = ({ hotelCode, hotelBrand, startDate, endDate, numGuests, dateFormat }) => {
  if (!checkIfTelegraphEnabled({ hotelCode, hotelBrand })) {
    return false;
  }

  const { BookingWidget } = window;
  if (!BookingWidget) {
    return false;
  }

  const {
    DEFAULT_DATE_FORMAT,
    TELEGRAPH_CONSTANTS: {
      TELEGRAPH_URL,
      TELEGRAPH_HOTEL_ID,
      TELEGRAPH_DATE_DEFAULT_JS_FORMAT,
    },
  } = BookingWidget.constants;

  const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

  const arriveMoment = moment(startDate, bookingDateFormat);
  let arrival = startDate;
  if (arriveMoment.isValid()) {
    arrival = arriveMoment.format(TELEGRAPH_DATE_DEFAULT_JS_FORMAT);
  }

  const departMoment = moment(endDate, bookingDateFormat);
  let departure = endDate;
  if (departMoment.isValid()) {
    departure = departMoment.format(TELEGRAPH_DATE_DEFAULT_JS_FORMAT);
  }

  const rooms = numGuests.length;

  const params = {
    hotel: TELEGRAPH_HOTEL_ID,
    arrival,
    departure,
    rooms,
    codeType: 'promo',
    code: '',
  };

  numGuests.forEach((guest, idx) => {
    const { numAdults, numChildren } = guest;
    params[`adults[${idx + 1}]`] = isNaN(numAdults) ? 0 : numAdults;
    params[`children[${idx + 1}]`] = isNaN(numChildren) ? 0 : numChildren;
  });

  const qsParams = Object.keys(params).map((key) => {
    const value = params[key];
    if (!value) {
      return null;
    }
    return `${key}=${value}`;
  }).filter((p) => !!p).join('&');

  window.open(`${TELEGRAPH_URL}/?${qsParams}`, '_blank');
  return true;
};

// Synxis
const checkIfSynxisEnabled = ({ hotelCode, hotelBrand }) => {
  const { BookingWidget } = window;
  if (!BookingWidget) {
    return false;
  }

  const {
    SYNXIS_CONSTANTS: { SYNXIS_BRAND_CODES },
  } = BookingWidget.constants;

  const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
    const location = BookingWidget['allBrandsLocations'][key];
    return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
  });
  if (!hotelKey) {
    return false;
  }

  const hotelData = BookingWidget['allBrandsLocations'][hotelKey];
  const synxisSettings = hotelData['synxisSettings'];
  const brand = hotelData['brand'];
  const ratesApiSource = hotelData['ratesApiSource'];

  if (!synxisSettings) {
    return false;
  }

  const synxisBrandCode = SYNXIS_BRAND_CODES[brand];
  if (!synxisBrandCode) {
    return false;
  }

  if (ratesApiSource !== 'ireckonu_api') {
    return false;
  }

  if (!synxisSettings.enableSynxisHotel || !synxisSettings.synxisChainId) {
    return false;
  }

  return true;
};

const redirectToSynxis = ({ hotelCode, hotelBrand, startDate, endDate, numGuests, dateFormat }) => {
  if (!checkIfSynxisEnabled({ hotelCode, hotelBrand })) {
    return false;
  }

  const { BookingWidget } = window;

  const {
    DEFAULT_DATE_FORMAT,
    SYNXIS_CONSTANTS: {
      SYNXIS_URL,
      SYNXIS_DATE_DEFAULT_JS_FORMAT,
      SYNXIS_BRAND_CODES,
    },
  } = BookingWidget.constants;

  const hotelKey = Object.keys(BookingWidget['allBrandsLocations']).find((key) => {
    const location = BookingWidget['allBrandsLocations'][key];
    return location.isHotel && location.hotelCode === hotelCode && location.brand === hotelBrand;
  });

  const hotelData = BookingWidget['allBrandsLocations'][hotelKey];
  const synxisSettings = hotelData['synxisSettings'];
  const brand = hotelData['brand'];
  const synxisBrandCode = SYNXIS_BRAND_CODES[brand];

  const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

  const arriveMoment = moment(startDate, bookingDateFormat);
  let arrive = startDate;
  if (arriveMoment.isValid()) {
    arrive = arriveMoment.format(SYNXIS_DATE_DEFAULT_JS_FORMAT);
  }

  const departMoment = moment(endDate, bookingDateFormat);
  let depart = endDate;
  if (departMoment.isValid()) {
    depart = departMoment.format(SYNXIS_DATE_DEFAULT_JS_FORMAT);
  }

  const adultsCounts = [];
  const childrenCounts = [];
  numGuests.forEach((guest) => {
    const { numAdults, numChildren } = guest;
    adultsCounts.push(isNaN(numAdults) ? 0 : numAdults);
    childrenCounts.push(isNaN(numChildren) ? 0 : numChildren);
  });

  const adult = adultsCounts.join(',');
  const child = childrenCounts.join(',');
  const rooms = numGuests.length;

  const params = {
    Hotel: synxisSettings.synxisHotelId,
    Chain: synxisSettings.synxisChainId,
    theme: synxisBrandCode,
    config: synxisBrandCode,
    arrive,
    depart,
    rooms,
    adult,
    child,
  };

  const qsParams = Object.keys(params).map((key) => {
    const value = params[key];
    if (!value) {
      return null;
    }
    return `${key}=${value}`;
  }).filter((p) => !!p).join('&');

  window.open(`${SYNXIS_URL}/?${qsParams}`, '_blank');
  return true;
};

// Thredbo rates
const redirectToThredboRates = ({ hotel, numGuests, startDate, endDate, dateFormat }) => {
  const { BookingWidget } = window;
  if (!BookingWidget) {
    return false;
  }

  const {
    THREDBO_CONSTANTS: {
      RATES_URL,
      BRAND: THREDBO_BRAND,
      HOTEL_CODE: THREDBO_HOTEL_CODE,
    },
  } = BookingWidget.constants;

  if (!hotel['redirectToThredboRates']) {
    return false;
  }

  const rooms = numGuests.length;
  const adultsPerRoom = [];
  const kidsPerRoom = [];
  const childAgesPerRoom = [];

  numGuests.forEach((guest) => {
    const { numAdults, numChildren } = guest;
    const adultCount = isNaN(numAdults) ? 0 : Number(numAdults);
    const kidCount = isNaN(numChildren) ? 0 : Number(numChildren);
    adultsPerRoom.push(adultCount);
    kidsPerRoom.push(kidCount);
    childAgesPerRoom.push(kidCount > 0 ? Array(kidCount).fill(0).join(',') : '');
  });

  const adults = adultsPerRoom.join(',');
  const kids = kidsPerRoom.join(',');
  const childAges = childAgesPerRoom.filter((ages) => ages !== '').join('|');

  const checkinDayjs = dayjs(startDate, dateFormat);
  const checkin = checkinDayjs.isValid() ? checkinDayjs.format('YYYY-MM-DD') : null;
  const checkoutDayjs = dayjs(endDate, dateFormat);
  const checkout = checkoutDayjs.isValid() ? checkoutDayjs.format('YYYY-MM-DD') : null;

  const ratesParams = {
    brand: THREDBO_BRAND,
    hotelCode: THREDBO_HOTEL_CODE,
    rooms,
    adults,
    kids,
    childAges,
    checkin,
    checkout,
  };

  const qsParams = Object.keys(ratesParams).map((key) => {
    const value = ratesParams[key];
    if (value === '' || value === null || value === undefined) {
      return null;
    }
    return `${key}=${value}`;
  }).filter((p) => !!p).join('&');

  const [ratesBaseUrl, ratesHash] = RATES_URL.split('#');
  const ratesUrl = ratesHash ? `${ratesBaseUrl}?${qsParams}/#${ratesHash}` : `${ratesBaseUrl}?${qsParams}`;
  window.open(ratesUrl, '_blank');

  return true;
};

// Inntopia
const redirectToInntopia = ({ hotelCode, startDate, endDate, numGuests, dateFormat }) => {
  const { BookingWidget } = window;
  if (!BookingWidget) {
    return false;
  }

  const {
    DEFAULT_DATE_FORMAT,
    INNTOPIA_CONSTANTS: {
      INNTOPIA_URL,
      INNTOPIA_SUPPLIER_ID,
      INNTOPIA_DATE_DEFAULT_JS_FORMAT,
      INNTOPIA_HOTEL_CODE,
    },
  } = BookingWidget.constants;

  if (hotelCode !== INNTOPIA_HOTEL_CODE) {
    return false;
  }

  const bookingDateFormat = dateFormat || DEFAULT_DATE_FORMAT;

  const arriveMoment = moment(startDate, bookingDateFormat);
  let arrival = startDate;
  if (arriveMoment.isValid()) {
    arrival = arriveMoment.format(INNTOPIA_DATE_DEFAULT_JS_FORMAT);
  }

  const departMoment = moment(endDate, bookingDateFormat);
  let departure = endDate;
  if (departMoment.isValid()) {
    departure = departMoment.format(INNTOPIA_DATE_DEFAULT_JS_FORMAT);
  }

  const params = {
    supplierid: INNTOPIA_SUPPLIER_ID,
    arrivaldate: arrival,
    departuredate: departure,
  };

  numGuests.forEach((guest) => {
    const { numAdults, numChildren } = guest;
    params['adultcount'] = isNaN(numAdults) ? 0 : numAdults;
    params['childCount'] = isNaN(numChildren) ? 0 : numChildren;
  });

  params['childagearray'] = '#Availability';

  const qsParams = Object.keys(params).map((key) => {
    const value = params[key];
    if (!value) {
      return null;
    }
    return `${key}=${value}`;
  }).filter((p) => !!p).join('&');

  window.open(`${INNTOPIA_URL}/?${qsParams}`, '_blank');
  return true;
};

// Third party
const redirectToThirdPartyBookingSites = ({ hotel, startDate, endDate, dateFormat }) => {
  if (!startDate || !endDate) {
    return false;
  }

  const numGuests = [{ numAdults: 2, numChildren: 0 }];

  if (redirectToThredboRates({
    hotel,
    numGuests,
    startDate,
    endDate,
    dateFormat,
  })) {
    return true;
  }

  if (redirectToInntopia({
    hotelCode: hotel['hotelCode'],
    startDate,
    endDate,
    numGuests,
    dateFormat,
  })) {
    return true;
  }

  if (redirectToSynxis({
    hotelCode: hotel['hotelCode'],
    hotelBrand: hotel['brand'],
    startDate,
    endDate,
    numGuests,
    dateFormat,
  })) {
    return true;
  }

  if (redirectToTelegraph({
    hotelCode: hotel['hotelCode'],
    hotelBrand: hotel['brand'],
    startDate,
    endDate,
    numGuests,
    dateFormat,
  })) {
    return true;
  }

  return false;
};

// NRMA
const getNRMAToken = () => {
  if (!window.NRMA_Membership) {
    return null;
  }
  if (typeof window.NRMA_Membership.getToken !== 'function') {
    return null;
  }
  return window.NRMA_Membership.getToken();
};

// Booking redirect builder
const buildBookingRedirectUrl = (hotel, params) => {
  if ('bookingTarget' in hotel && hotel['bookingTarget'] && (hotel['bookingTarget']['domain'] !== 'rydges.com')) {
    const nrmaToken = getNRMAToken();
    return hotel['bookingTarget']['rates_page'] + '?' + $.param({
      ...params,
      nrmaToken,
    });
  }

  helpers.docCookies.setItem('rsd_ba_b', JSON.stringify(params), 3600, '/', 'rydges.com');
  return window.Rydges['ratesPageUrl'];
};

const hotelsResults = () => {
  jQuery(document).ready(function($) {
    // Hotels
    const hotelsWrapper = $('#global-hotels-wrapper');
    if (hotelsWrapper.length) {
      // Equal height for elements
      helpers.equalHeightElements('.single-hotel-wrapper .hotel-info .hotel-name.equal-height');
      helpers.equalHeightElements('.single-hotel-wrapper .hotel-info .hotel-bookings.equal-height');

      // Cancel token source
      let cancelTokenSource = null;
      let currentFacilities = '';
      let headingSuffix = $('#global-hotels-heading-label').text().trim().replace(/^Showing \d+ hotels?/, '');

      const countShownCards = function($cards) {
        return $cards.toArray().filter((card) => card.style.display !== 'none').length;
      };

      const applyFacilitiesFilter = function() {
        const selectedFacilities = currentFacilities.length ? currentFacilities.split(',') : [];

        hotelsWrapper.find('.single-hotel').each(function() {
          const $card = $(this);
          const facilitiesAttr = $card.attr('data-facilities') || '';
          const hotelFacilities = facilitiesAttr.length ? facilitiesAttr.split(',') : [];
          const matches = !selectedFacilities.length || selectedFacilities.every((facility) => hotelFacilities.indexOf(facility) > -1);

          $card.toggle(matches);
        });

        hotelsWrapper.find('h3[data-brand]').each(function() {
          const $heading = $(this);
          const brand = $heading.data('brand');
          const $brandWrapper = $heading.next('.hotel-wrapper');
          const visibleCount = countShownCards($brandWrapper.find('.single-hotel'));

          $heading.text(`${visibleCount} ${brand}${visibleCount === 1 ? ' hotel' : ' hotels'}`);
          $heading.toggle(visibleCount > 0);
          $brandWrapper.toggle(visibleCount > 0);
        });

        const totalVisibleCount = countShownCards(hotelsWrapper.find('.single-hotel'));

        $('#global-hotels-heading-label').text(`Showing ${totalVisibleCount} hotel${totalVisibleCount === 1 ? '' : 's'}${headingSuffix}`);

        // Equal height for elements
        helpers.equalHeightElements('.single-hotel-wrapper .hotel-info .hotel-name.equal-height');
        helpers.equalHeightElements('.single-hotel-wrapper .hotel-info .hotel-bookings.equal-height');
      };

      const handleHotelsResults = function() {
        if (cancelTokenSource) {
          cancelTokenSource.cancel('New request initiated, cancel previous.');
        }
        cancelTokenSource = axios.CancelToken.source();

        const searchNoticeWrapper = $('#global-hotels-search-notice-wrapper');
        const searchNoticeLabel = $('#global-hotels-search-notice-label');
        const headingLabel = $('#global-hotels-heading-label');
        const subHeadingLabel = $('#global-hotels-sub-heading-label');
        const skeleton = $('#global-hotels-skeleton');
        const params = helpers.getParameters();
        const location = params['location'] || '';

        searchNoticeWrapper.hide();
        searchNoticeLabel.text('');
        headingLabel.text('');
        subHeadingLabel.text('');
        hotelsWrapper.html('');
        skeleton.show();

        const fireRequest = () => {
          const requestParams = {
            'location': location,
            'locationLat': location === 'Current Location' ? (currentLocationLat || '') : '',
            'locationLng': location === 'Current Location' ? (currentLocationLng || '') : '',
            'brand': params['brand'] || '',
          };

          axios.get(`${window.Rydges['restUrl']}global-hotels`, {
            params: requestParams,
            cancelToken: cancelTokenSource.token,
          }).then((axiosResponse) => {
            if (200 === axiosResponse.status) {
              const response = axiosResponse.data;

              skeleton.hide();

              const searchNotice = response['search_notice'];
              const heading = response['heading'];
              const subHeading = response['sub_heading'];
              const html = response['html'];

              if (html.length) {
                searchNoticeWrapper.toggle(searchNotice.length > 0);
                searchNoticeLabel.text(searchNotice);
                headingLabel.text(heading);
                headingSuffix = heading.replace(/^Showing \d+ hotels?/, '');
                subHeadingLabel.text(subHeading);
                hotelsWrapper.html(html);
                applyFacilitiesFilter();

                // Update URL
                helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

                // Equal height for elements
                helpers.equalHeightElements('.single-hotel-wrapper .hotel-info .hotel-name.equal-height');
                helpers.equalHeightElements('.single-hotel-wrapper .hotel-info .hotel-bookings.equal-height');

                // Booking form loaded
                $(document).trigger(constants.EVENT_BOOKING_FORM_LOADED);
              }
            }
          }).catch((error) => {
            console.log(error);
          });
        };

        if (location === 'Current Location') {
          getCurrentLocation(fireRequest);
        } else {
          currentLocationLat = null;
          currentLocationLng = null;
          fireRequest();
        }
      };

      applyFacilitiesFilter();

      // Refresh on initial load when "Current Location" is in play
      if ((helpers.getParameters()['location'] || '') === 'Current Location') {
        handleHotelsResults();
      }

      const searchAccommodationsForm = $('.search-accommodations-form-wrapper');
      if (searchAccommodationsForm.length) {
        // Reload results
        $(document).on(constants.EVENT_SUBMIT_CLICKED_SEARCH, () => {
          handleHotelsResults();
        });

        $(document).on(constants.EVENT_FACILITES_FILTER_CHANGED_SEARCH, (e, facilities) => {
          currentFacilities = facilities || '';
          applyFacilitiesFilter();
        });
      }

      // Flip the card
      hotelsWrapper.on('click', '.btn-flip', function(e) {
        e.preventDefault();

        const el = $(this);
        const card = el.closest('.hotel-flip-card-wrapper');
        const hotel = card.data('hotel');
        if (!hotel) {
          return;
        }

        const accommodationFormWrapper = $('.search-accommodations-form-wrapper');
        const form = accommodationFormWrapper.find('form');
        const startDateVal = form.find('[name="startDate"]').val();
        const endDateVal = form.find('[name="endDate"]').val();

        if (startDateVal && endDateVal) {
          const startDate = moment(new Date(startDateVal)).format(constants.DATE_FORMAT_AUS);
          const endDate = moment(new Date(endDateVal)).format(constants.DATE_FORMAT_AUS);

          if (redirectToThirdPartyBookingSites({
            hotel,
            startDate,
            endDate,
            dateFormat: constants.DATE_FORMAT_AUS,
          })) {
            return;
          }

          const params = {
            hotelCode: hotel['hotelCode'],
            startDate,
            endDate,
            numRooms: 1,
            numGuests: [{ numAdults: 2, numChildren: 0 }],
          };

          if ('bookingTarget' in hotel && hotel['bookingTarget']) {
            params.channelCode = hotel['bookingTarget']['channel_code'];
          } else {
            params.channelCode = window.Rydges['defaultChannelCode'];
          }

          window.location = buildBookingRedirectUrl(hotel, params);
          return;
        }

        // Otherwise: flip the card to reveal the date picker form
        const allCards = hotelsWrapper.find('.hotel-flip-card .hotel-flip-card-wrapper');
        allCards.removeClass('wrapper-flipped');
        card.addClass('wrapper-flipped');
        hotelsWrapper.find('.hotel-flip-card .flip-card-wrapper').removeClass('card-flipped');
        card.find('.flip-card-wrapper').addClass('card-flipped');
      });

      // Unflip the card
      hotelsWrapper.on('click', '.btn-unflip', function(e) {
        e.preventDefault();

        const card = $(this).closest('.hotel-flip-card-wrapper');
        card.removeClass('wrapper-flipped');
        card.find('.flip-card-wrapper').removeClass('card-flipped');
      });

      // Submit the booking form on the back of the flipped card
      hotelsWrapper.on('submit', '.hotel-booking-form', function(e) {
        e.preventDefault();

        const form = $(this);
        const card = form.closest('.hotel-flip-card-wrapper');
        const hotel = card.data('hotel');
        const dayUseInput = form.find('[name="dayUse"]');
        const startDateVal = form.find('[name="startDate"]').val();
        const endDateVal = form.find('[name="endDate"]').val();

        if (!hotel) {
          return;
        }

        if (startDateVal === '' || endDateVal === '') {
          form.find('.date-validator').show();
          return;
        }
        form.find('.date-validator').hide();

        const startDate = moment(new Date(startDateVal)).format(constants.DATE_FORMAT_AUS);
        const endDate = moment(new Date(endDateVal)).format(constants.DATE_FORMAT_AUS);

        if (redirectToThirdPartyBookingSites({
          hotel,
          startDate,
          endDate,
          dateFormat: constants.DATE_FORMAT_AUS,
        })) {
          return;
        }

        const params = {
          hotelCode: hotel['hotelCode'],
          startDate,
          endDate,
          numRooms: 1,
          numGuests: [{ numAdults: 2, numChildren: 0 }],
        };

        if (hotel['enableDayUse'] && dayUseInput.length) {
          if (dayUseInput.is(':checked')) {
            params.dayUse = true;
            params.blockCode = hotel['dayUseBlockCode'];
          } else {
            params.dayUse = false;
            params.blockCode = '';
          }
        }

        if ('bookingTarget' in hotel && hotel['bookingTarget']) {
          params.channelCode = hotel['bookingTarget']['channel_code'];
        } else {
          params.channelCode = window.Rydges['defaultChannelCode'];
        }

        const submitUrl = buildBookingRedirectUrl(hotel, params);

        if (submitUrl && submitUrl.length > 0) {
          form.find('button[type="submit"]').prop('disabled', true);
          form.find('.spinner-loader').removeClass('hidden');
          window.location = submitUrl;
        }
      });

      // Save recent viewed cookie when navigating to a hotel page
      hotelsWrapper.on('click', '.hotel-link', function() {
        const card = $(this).closest('.hotel-flip-card-wrapper');
        if (!card.length) {
          return;
        }

        const hotel = card.data('hotel');
        if (!hotel) {
          return;
        }

        saveRecentViewed(hotel['hotelName'], hotel['brand']);
      });

      const globalHotelsViewTypes = $('#global-hotels-view-types');
      if (globalHotelsViewTypes) {
        const items = globalHotelsViewTypes.find('.view-type-item');

        items.on('click', function(e) {
          e.preventDefault();

          const el = $(this);
          const view = el.data('view');

          items.removeClass('active');
          el.addClass('active');

          $(document).trigger(constants.EVENT_VIEW_TYPE_CHANGED, [view]);

          if (view === 'map') {
            $('#global-hotels-grid-container').hide();
            $('#global-hotels-map-container').show();
          } else {
            $('#global-hotels-map-container').hide();
            $('#global-hotels-grid-container').show();

            // Equal height for elements
            helpers.equalHeightElements('.single-hotel-wrapper .hotel-info .hotel-name.equal-height');
            helpers.equalHeightElements('.single-hotel-wrapper .hotel-info .hotel-bookings.equal-height');

            // Booking form loaded
            $(document).trigger(constants.EVENT_BOOKING_FORM_LOADED);
          }
        });
      }
    }

    // Map view
    const globalHotelsMapWrapper = $('#global-hotels-map-wrapper');
    if (globalHotelsMapWrapper.length) {
      ReactDOM.render(<AppGlobalHotelsMap />, globalHotelsMapWrapper[0]);
    }
  });
};

export default hotelsResults;



// WEBPACK FOOTER //
// ./scripts/routes/modules/hotelsResults.js